import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { Box, SimpleGrid, Text } from '@chakra-ui/react'
import { Container } from 'src/components'
import { GreyCarIcon } from 'src/icons'
import Column from './Column'

interface Props {
  title: string
  engineTitle: string
  engine: Array<VehicleGlobal.Feature>
  dimensionsTitle: string
  dimensions: Array<VehicleGlobal.Feature>
  consumptionTitle: string
  consumption: Array<VehicleGlobal.Feature>
  children?: ReactNode
}

const TitleContent = styled.span`
  & svg {
    display: inline;
    margin-right: 0.5rem;
    margin-bottom: -6px;
  }
`

const VehicleDetails: FC<Props> = ({
  title,
  engineTitle,
  engine,
  dimensionsTitle,
  dimensions,
  consumptionTitle,
  consumption,
  children,
}) => (
  <Box bg="baseNeutral.200" paddingY={{ base: 0, md: 'xxl6' }}>
    <Container paddingY="0">
      <Box bg="baseNeutral.300" padding="m" borderTopRadius={{ base: '0', md: '10' }}>
        <Text
          as="h2"
          fontFamily="Montserrat-SemiBold"
          fontSize={{ base: '1.25rem', md: '1.5rem' }}
          lineHeight="31px"
          letterSpacing={{ base: '0.58px', md: '0.68px' }}
          textAlign="center"
          color="baseDark"
          py="xxl"
        >
          <TitleContent>
            <Box display={{ base: 'none', md: 'inline' }}>
              <GreyCarIcon />
            </Box>
            {title}
          </TitleContent>
        </Text>
      </Box>

      <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing="l" textAlign="center">
        <Column title={engineTitle} items={engine} />
        <Column title={dimensionsTitle} items={dimensions} />
        <Column title={consumptionTitle} items={consumption} />
      </SimpleGrid>

      {children && (
        <Box pt="m" pb={{ base: 'l', md: 0 }}>
          {children}
        </Box>
      )}
    </Container>
  </Box>
)

export default VehicleDetails
